import type { ReactNode } from 'react';

export interface SummaryItem {
  label: string;
  value: ReactNode;
  /** Text colour class for the value, e.g. 'text-teal-800'. */
  tone?: string;
}

/** Gray strip of 2–4 label/value boxes used at the top of drawer cards. */
export function SummaryStrip({ items }: { items: SummaryItem[] }) {
  return (
    <div
      className="grid divide-x divide-gray-200 rounded-lg border border-gray-200 bg-gray-50"
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
    >
      {items.map((item) => (
        <div key={item.label} className="min-w-0 px-3 py-2.5">
          <p className="text-xs text-gray-500">{item.label}</p>
          <p className={`mt-0.5 truncate text-[15px] font-semibold tabular-nums ${item.tone ?? 'text-gray-800'}`}>
            {item.value}
          </p>
        </div>
      ))}
    </div>
  );
}
